var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect } from "react";
import leadDi from "../../components/Features/LeadDashboard/di/serviceLocator";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Newlead } from "./Newlead";
import SalesToasts from "../../../shared-library/components/Toasts";
import { LogoLoader } from "../../../shared-library/components/Loader";
import { IEditLeadAccessPayloadEnum } from "@domains/salesFeatures/Lead/entities/IEditLeadAccess";
export var EDisplayComponent;
(function (EDisplayComponent) {
    EDisplayComponent["LOADER"] = "LOADER";
    EDisplayComponent["LEAD_COMPONENT"] = "LEAD_COMPONENT";
    EDisplayComponent["TOAST_MESSAGE"] = "TOAST_MESSAGE";
})(EDisplayComponent || (EDisplayComponent = {}));
export var LeadPageHOC = function () {
    var _a, _b, _c;
    var _d = useParams(), leadid = _d.leadid, partnerOrClient = _d.partnerOrClient, isParentOrChild = _d.isParentOrChild, parentLeadId = _d.parentLeadId;
    var location = useLocation();
    var navigate = useNavigate();
    //go back to lead-dashboard with params logic will be centralized here when retain and HoC goes live(onSubmit and cancel , unauthorised)
    var params = (_a = location === null || location === void 0 ? void 0 : location.state) === null || _a === void 0 ? void 0 : _a.param;
    var leadTableTab = (_c = (_b = location === null || location === void 0 ? void 0 : location.state) === null || _b === void 0 ? void 0 : _b.leadTableTab) !== null && _c !== void 0 ? _c : 0;
    leadid = !!leadid
        ? window.atob(leadid) !== "null"
            ? atob(leadid)
            : undefined
        : undefined;
    var _e = __read(React.useState({
        displayComponent: EDisplayComponent.LOADER,
        toastMessage: "",
    }), 2), uiRendererData = _e[0], setUIRendererData = _e[1];
    var generateMainComponent = function () {
        switch (uiRendererData.displayComponent) {
            case EDisplayComponent.LOADER:
                return React.createElement(LogoLoader, null);
            case EDisplayComponent.LEAD_COMPONENT:
                return React.createElement(Newlead, null);
            case EDisplayComponent.TOAST_MESSAGE:
                return (React.createElement(SalesToasts, { show: true, setShow: function () {
                        navigate("/dashboard/lead-dashboard" + "".concat(params ? "?" + params : ""), { state: { iamBack: true, leadTableTab: leadTableTab } });
                    }, position: "middle-center", message: React.createElement("span", { dangerouslySetInnerHTML: {
                            __html: uiRendererData.toastMessage,
                        } }), isError: true, parentClass: "lead-create-toast assign-lead blur-sales-toast" }));
        }
    };
    var checkIsAuthorizedToEdit = function () {
        leadDi.leads
            .editAccessLead({
            strLeadId: leadid,
            strFlag: IEditLeadAccessPayloadEnum.EDIT_FLAG,
        })
            .then(function (resp) {
            var _a;
            if (resp && resp.response) {
                setUIRendererData({
                    displayComponent: EDisplayComponent.LEAD_COMPONENT,
                    toastMessage: "",
                });
            }
            else {
                setUIRendererData({
                    displayComponent: EDisplayComponent.TOAST_MESSAGE,
                    toastMessage: (_a = resp === null || resp === void 0 ? void 0 : resp.responseDescription) !== null && _a !== void 0 ? _a : "Unauthorised for Edit",
                });
            }
        })
            .catch(function (error) {
            setUIRendererData({
                displayComponent: EDisplayComponent.TOAST_MESSAGE,
                toastMessage: "Something went wrong.please try again later",
            });
        });
    };
    useEffect(function () {
        if (!!leadid) {
            checkIsAuthorizedToEdit();
        }
    }, [leadid]);
    return React.createElement(React.Fragment, null, generateMainComponent());
};
export default LeadPageHOC;
